import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { 
  BotelManagerPage,
  HostDashboardPage,
  HostOnboarding,
  HostOnboardingStep1,
  HostOnboardingStep2,
  HostOnboardingStep3,
  HostOnboardingStep4,
  HostOnboardingSuccess 
} from '../pages/host';
import HostPasswordSetup from '../pages/host/HostPasswordSetup';

export const HostRoutes = [
  // Host Dashboard
  <Route 
    key="host-dashboard" 
    path="/host/dashboard" 
    element={
        <ProtectedRoute requiredRole="host_partner">
        <HostDashboardPage />
      </ProtectedRoute>
    } 
  />,

  // Botel Manager
  <Route 
    key="host-botel-manager" 
    path="/host/botel-manager" 
    element={
      <ProtectedRoute requiredRole="host_partner">
        <BotelManagerPage />
      </ProtectedRoute>
    } 
  />,
  
  // Host Onboarding Flow - Public routes (no auth required)
  <Route 
    key="host-onboarding-step1" 
    path="/host/onboarding/step-1" 
    element={
      <HostOnboarding>
        <HostOnboardingStep1 />
      </HostOnboarding>
    } 
  />,
  <Route 
    key="host-onboarding-step2" 
    path="/host/onboarding/step-2" 
    element={
      <HostOnboarding>
        <HostOnboardingStep2 />
      </HostOnboarding>
    } 
  />,
  <Route 
    key="host-onboarding-step3" 
    path="/host/onboarding/step-3" 
    element={
      <HostOnboarding>
        <HostOnboardingStep3 />
      </HostOnboarding>
    } 
  />,
  <Route 
    key="host-onboarding-step4" 
    path="/host/onboarding/step-4" 
    element={
      <HostOnboarding>
        <HostOnboardingStep4 />
      </HostOnboarding>
    } 
  />,
  <Route 
    key="host-onboarding-success" 
    path="/host/onboarding/success" 
    element={<HostOnboardingSuccess />} 
  />,
  
  // Password setup route (public)
  <Route 
    key="host-password-setup" 
    path="/host/setup-password" 
    element={<HostPasswordSetup />} 
  />,
  
  // Legacy route - redirect to onboarding
  <Route 
    key="become-host" 
    path="/become-a-host" 
    element={
      <HostOnboarding>
        <HostOnboardingStep1 />
      </HostOnboarding>
    } 
  />
]; 